/**
 * Full-width warning band, above the sidebar and the content — not inside
 * the content column. Not dismissible: it states a fact about the session,
 * it isn't a notification about one.
 * Spec: assets/handoffs/design_handoff_app_shell, Rules — impersonation.
 *
 * @param {string} accountName - truncates with an ellipsis at 480px
 * @param {function} onStop
 */
import React from "react";
import Icon from "../../../theme/untitled/icons/Icon";
import styles from "./ImpersonationBar.module.scss";

const ImpersonationBar = ({ accountName, onStop }) => (
  <div className={styles.bar} role="status">
    <Icon name="AlertTriangle" className={styles.icon} />
    <p className={styles.copy}>
      Viewing <b className={styles.accountName} title={accountName}>{accountName}</b> as an
      administrator. Changes you make are saved to their account.
    </p>
    <button type="button" className={styles.stopButton} onClick={onStop}>
      Stop impersonating
    </button>
  </div>
);

export default ImpersonationBar;
